import React from 'react';
import Modal from './Modal';
import './ConfirmModal.css';
import { useTranslation } from 'react-i18next';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'confirm' // 'confirm', 'alert', 'success', 'error'
}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };
  
  const { t } = useTranslation();

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'confirm':
        return '?';
      default:
        return 'ℹ';
    }
  };

  const getIconClass = () => {
    switch (type) {
      case 'success':
        return 'confirm-icon-success';
      case 'error':
        return 'confirm-icon-error';
      case 'confirm':
        return 'confirm-icon-warning';
      default:
        return 'confirm-icon-info';
    }
  };

  const footer = (
    <div className="confirm-actions">
      {type === 'confirm' ? (
        <>
          <button className="confirm-btn confirm-btn-cancel" onClick={onClose}>
            {cancelText}
          </button>
          <button className="confirm-btn confirm-btn-confirm" onClick={handleConfirm}>
            {confirmText}
          </button>
        </>
      ) : (
        <button className="confirm-btn confirm-btn-primary" onClick={onClose}>
          OK
        </button>
      )}
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} footer={footer}>
      <div className="confirm-content">
        <div className={`confirm-icon ${getIconClass()}`}>
          {getIcon()}
        </div>
        <p className="confirm-message">{message}</p>
      </div>
    </Modal>
  );
};

export default ConfirmModal;